import config from '../config';
const SiteAssets = config.AWS.SiteAssets;


export default (asset) => SiteAssets + '/' + asset;



// WEBPACK FOOTER //
// ./src/utils/assetsUrl.js